module.exports = __webpack_public_path__ + "img/okazukan.bc654ea2.png";